import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../core';
import { RepresentanteJaCadastrado } from './representante-ja-cadastrado';

@Injectable({
    providedIn: 'root'
})
export class RepresentanteValidacoesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/representante`;
    }

    /** Obtem o representante já cadastrado através do seu CNPJ/CPF quando houver um */
    getRepresentanteJaCadastrado(idPessoa: number, cnpjCpf: string): Observable<RepresentanteJaCadastrado> {
        // Params
        let params = new HttpParams();
        // ID da Pessoa
        if (idPessoa) {
            params = params.append('idPessoa', idPessoa.toString());
        }
        // CNPJ/CPF
        if (cnpjCpf) {
            params = params.append('cnpjCpf', cnpjCpf);
        }

        return this.customHttp.get(`${this.pathApi}/0/validacoes/jacadastrado`, {params});
    }
}
